// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3o1Ao","notes":"Notes_notes__3g72c"};